import { isEmpty } from "lodash";
import React from "react";
import { Container } from "reactstrap";

const Header = ({ children, classes }) => (
  <div className={isEmpty(classes) ? "header pb-3 pt-3 pt-md-7" : classes}>
    <Container fluid>
      <div className="header-body">{children}</div>
    </Container>
  </div>
);

export default Header;
